/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Kit 2 React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Kit 2 React using thie file.
 */

export default {
  mode: "dark",

  background: {
    default: "#121212", // 标准深色背景
  },

  text: {
    main: "#e0e0e0", // 主文字更亮
    focus: "#ffffff", // 聚焦时更清晰
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#121212", // 白色在深色下应为背景色（反色逻辑）
    focus: "#1e1e1e",
  },

  black: {
    light: "#ffffff",
    main: "#ffffff",
    focus: "#e0e0e0",
  },

  primary: {
    main: "#ec407a", // 稍提亮，增强可视性
    focus: "#f06292",
  },

  secondary: {
    main: "#b0b0b0", // 原 #7b809a 太暗，提升亮度
    focus: "#c5c5c5",
  },

  info: {
    main: "#4da7f1", // 提亮蓝色
    focus: "#64b5f6",
  },

  success: {
    main: "#66bb6a", // 使用原 gradient.main，更醒目
    focus: "#81c784",
  },

  warning: {
    main: "#ffa726", // 使用原 gradient.main
    focus: "#ffb74d",
  },

  error: {
    main: "#ef5350", // 使用原 gradient.main
    focus: "#f46c69",
  },

  light: {
    main: "#2b2b2b", // 原 light 是背景色，深色下应为深灰
    focus: "#333333",
  },

  dark: {
    main: "#e0e0e0", // 原 dark 是文字色，深色下应为浅灰
    focus: "#ffffff",
  },

  grey: {
    100: "#212121",
    200: "#2b2b2b",
    300: "#333333",
    400: "#424242",
    500: "#616161",
    600: "#9e9e9e",
    700: "#bdbdbd",
    800: "#e0e0e0",
    900: "#ffffff",
  },

  gradients: {
    primary: {
      main: "#F06292",
      state: "#EC407A",
    },
    secondary: {
      main: "#9c9c9c",
      state: "#b0b0b0",
    },
    info: {
      main: "#64B5F6",
      state: "#4DA7F1",
    },
    success: {
      main: "#81C784",
      state: "#66BB6A",
    },
    warning: {
      main: "#FFB74D",
      state: "#FFA726",
    },
    error: {
      main: "#F46C69",
      state: "#EF5350",
    },
    light: {
      main: "#333333",
      state: "#2b2b2b",
    },
    dark: {
      main: "#ffffff",
      state: "#e0e0e0",
    },
  },

  socialMediaColors: {
    facebook: { main: "#5a7bc7", dark: "#6a8bd6" },
    twitter: { main: "#7accf6", dark: "#8ed5f9" },
    instagram: { main: "#6e8abf", dark: "#7f9bcf" },
    linkedin: { main: "#3a9ae6", dark: "#4aaaf0" },
    pinterest: { main: "#e64a4a", dark: "#ff5f5f" },
    youtube: { main: "#ff4c4c", dark: "#ff6969" },
    vimeo: { main: "#4dc1f9", dark: "#66ccff" },
    slack: { main: "#5fcfbf", dark: "#70dfcf" },
    dribbble: { main: "#f57ebd", dark: "#ff93ce" },
    github: { main: "#444c56", dark: "#5a636e" },
    reddit: { main: "#ff6a33", dark: "#ff855c" },
    tumblr: { main: "#5a6d8c", dark: "#6f82a3" },
  },

  badgeColors: {
    primary: { background: "#5d2a3a", text: "#f8b3ca" },
    secondary: { background: "#3a3c45", text: "#d7d9e1" },
    info: { background: "#2a4a6b", text: "#aecef7" },
    success: { background: "#2d4a3d", text: "#bce2be" },
    warning: { background: "#5a422a", text: "#ffd59f" },
    error: { background: "#5a3a38", text: "#fcd3d0" },
    light: { background: "#1e1e1e", text: "#8a94a3" },
    dark: { background: "#2c3c58", text: "#8097bf" },
  },

  coloredShadows: {
    primary: "#ec407a",
    secondary: "#b0b0b0",
    info: "#4da7f1",
    success: "#66bb6a",
    warning: "#ffa726",
    error: "#ef5350",
    light: "#424242",
    dark: "#e0e0e0",
  },

  inputBorderColor: "#424242",

  tabs: {
    indicator: { boxShadow: "#424242" },
  },
};
